import { render, staticRenderFns } from "./AllowedInstanceTypes.vue?vue&type=template&id=73767e1a"
import script from "./AllowedInstanceTypes.vue?vue&type=script&lang=ts"
export * from "./AllowedInstanceTypes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports